import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { filter } from 'lodash'

import DockChat from './dock-chat'

import { toggleChat, addUserToChat, openChat, closeChat, changeTempChatId, setFocus } from 'state/actions'

import { 
	getCurrentUser,
	getCurrentAccount,
	getLastUnreadItem
} from 'state/selectors'

import { 
	isMobile, 
	doClickEventListeners,
} from 'utils'

import isEqual from 'react-fast-compare'

class Dock extends Component {
	chats = []
	shouldBlockTransition = false

	state = {
		currentlyFlashingChat: null,
		focusedChat: null,
	}

	// UNSAFE_componentWillMount(){
	// 	doClickEventListeners(this.handleClickOutside)
	// }

	componentDidMount(){
		this.checkForActiveChats()
	}

	checkForActiveChats = _ => {
		const {
			activeChats,
			userData,
			allChats,
			entities,
			openChat
		} = this.props

		// Only for page load/rehydrate
		if(activeChats.length || isMobile()){
			return 
		}

		userData && userData.chats.forEach(chatId => {
			const chatObject = allChats[chatId]

			if(chatObject){
				if(getLastUnreadItem(chatObject, userData, entities)){
					openChat(chatObject)
				}
			}
		})
	}

	componentWillUnmount(){
		doClickEventListeners(this.handleClickOutside, true)
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		let hasPropsChanged = false

		Object.keys(this.props).forEach(key => {
			if(this.props[key] !== nextProps[key]){
				hasPropsChanged = true
			}
		})

		const hasStateChanged = !isEqual(this.state, nextState)

		if(!hasPropsChanged && !hasStateChanged){
			return false
		}

		return true
	}

	handleClickOutside = e => {
		if(this.ref && !this.ref.contains(e.target)){
			let shouldUpdate = false

			Object.keys(this.props.chatFocusData).forEach((chat, isFocused) => {
				if(isFocused){
					shouldUpdate = true
				}
			})

			if(shouldUpdate){
				this.setFocus(null)
			}
        }
	}

	setFocus = chatId => {
		const {
			setFocus,
			accountData,
			userData,
			chatFocusData
		} = this.props

		let shouldSetFocusOverSocket = true

		// Is the socket value already true?
		if(chatId && chatFocusData && chatFocusData[userData.id] == chatId){
			shouldSetFocusOverSocket = false
		}

		if(shouldSetFocusOverSocket){
			setFocus(chatId, accountData.id, userData.id)
		}

		this.setState({
			focusedChat: chatId
		})
	}

	UNSAFE_componentWillUpdate = nextProps => {
		this.shouldBlockTransition = false

		if(this.props.activeChats.length == nextProps.activeChats.length){
			const currentActiveIndex = this.props.activeChats.findIndex(chat => {
				return chat.isOpen
			})

			const newActiveChatIndex = nextProps.activeChats.findIndex(chat => {
				return chat.isOpen
			})

			if(currentActiveIndex == newActiveChatIndex){
				this.shouldBlockTransition = true
			}
		}
	}

	componentDidUpdate = prevProps => {
		this.shouldBlockTransition = false

		if(this.props.userDataRefreshed && !prevProps.userDataRefreshed){
			setTimeout(_ => {
				this.checkForActiveChats()
			},1000)
		}
	}

	setCurrentlyFlashingChat = id => {
		this.setState({
			currentlyFlashingChat: id
		})
	}

	cancelNewChat = () => {
		const { setCurrentBigChat } = this.props

		if(setCurrentBigChat){
			setCurrentBigChat(null)
		}
	}

	render() {
		const {
			entities,
			userData,
			allChats,
			accountData,
			optimisticChat,
			activeChats,
			isBigChat,
			currentBigChatId,
			setCurrentBigChat,
			changeTempChatId,
			isBigChatOpen,
			setIsAsideVisibleOnSmallScreens
		} = this.props

		const {
			currentlyFlashingChat,
			focusedChat,
		} = this.state

		if(!allChats || !userData || isBigChatOpen){
			return null
		}

		this.chats = []

		activeChats.forEach((activeChat, index) => {
			let chatObject = allChats[activeChat.id]

			if(!chatObject || !chatObject.userIds || chatObject.is_assistant_chat){
				return
			}

			let initialChat = chatObject

			// not a group chat, and no messages?
			if(chatObject.userIds && chatObject.userIds.length == 2 && (!chatObject.chat_items || !chatObject.chat_items.length)){
				const otherUserId = chatObject.userIds.find(userId => {
					return userId !== userData.id
				})

				const allChatsWithOnlyThisUser = filter(allChats, chat => {
					if(chat && chat.userIds){
						return (chat.userIds.length == 2 && chat.userIds.indexOf(otherUserId) !== -1)
					}
				})

				allChatsWithOnlyThisUser.sort((a, b) => {
					return a.created_at.localeCompare(b.created_at)
				})

				chatObject = allChatsWithOnlyThisUser[0]

				if(!activeChat.tempId || activeChat.tempId !== chatObject.id){
					changeTempChatId(index, chatObject.id)
				}
			}else{
				if(activeChat.tempId){
					changeTempChatId(index, null, activeChat.id)
				}
			}

			if(!isMobile() || this.chats.length < 1){
				this.chats.push({
					chatObject,
					activeChat,
					initialChat
				})
			}
		})

		return (
			<section className={`dock ${ isBigChat ? 'is-big-chat' : ''}`} ref={ref => this.ref = ref} id="dock">
				<div className="chats-container">
					<ul className="chats">
						{ optimisticChat && 
							<DockChat 
								setFocus={this.setFocus} 
								userData={userData} 
								accountData={accountData} 
								optimistic={true}
							/>
						}
						{ this.chats.map((chat, index) => {
							// For me, ignore chatFocusData, only listen to state.
							const isFocused = (focusedChat == chat.chatObject.id || focusedChat == chat.initialChat.id)

							if(setCurrentBigChat){
								if(currentBigChatId !== chat.activeChat.id){
									return null 
								}
							}

							return (
								<DockChat 
									setFocus={this.setFocus} 
									isFocused={isFocused} 
									initialChat={chat.initialChat} 
									allChats={this.props.allChats} 
									key={chat.initialChat.id} 
									chatId={chat.initialChat.id}
									userData={userData} 
									accountData={accountData} 
									chatObject={chat.chatObject} 
									activeChat={chat.activeChat} 
									index={index} 
									entities={entities}
									shouldBlockTransition={this.shouldBlockTransition}
									currentlyFlashingChat={currentlyFlashingChat}
									setCurrentlyFlashingChat={this.setCurrentlyFlashingChat}
									isBigChat={isBigChat}
									setCurrentBigChat={setCurrentBigChat}
									cancelNewChat={this.cancelNewChat}
									setIsAsideVisibleOnSmallScreens={setIsAsideVisibleOnSmallScreens}
								/>
							)
						}) }
					</ul>
				</div>
			</section>
		)
	}
}

const mapStateToProps = state => {
	return {
		allChats: state.account.entities.chats,
		userData: getCurrentUser(state),
		accountData: getCurrentAccount(state),
		chatFocusData: state.auth.chatFocusData,
		entities: state.account.entities,
		optimisticChat: state.account.optimisticChat,
		hasHardSetState: state.account.hasHardSetState,
		userDataRefreshed: state.auth.userDataRefreshed,
		activeChats: state.auth.activeChats || [],
		isBigChatOpen: state.auth.isBigChatOpen
	};
}

export default withRouter(connect(mapStateToProps, { 
	toggleChat, 
	addUserToChat, 
	openChat, 
	closeChat, 
	changeTempChatId, 
	setFocus 
})(Dock));
